import React from 'react';
import Lottie from 'lottie-react';
import { Flex, Link, Text } from '@chakra-ui/react';

const NotFoundPage = () => {
  return (
    <Flex 
      minH='100vh' 
      w='100%'
      justifyContent='center'
      alignItems='center'
      flexDir='column'
    >
      <Lottie
        style={{
          paddingLeft: '15px',
        }}
        animationData={require('./animations/404.json')}
        autoplay
        loop
      />
      <Flex flexDir='column' textAlign='center'>
        <Text>
          Parece que estás perdido
        </Text>
        <Text>
          vuelve a <Link href='/'>Skyshops 🚀</Link>
        </Text>
      </Flex>
    </Flex>
  )
}

export default NotFoundPage;